/*
 * @Author: Teemo Ding
 * @Date: 2021-04-19 11:36:41
 * @LastEditTime: 2021-07-05 15:55:04
 * @LastEditors: Teemo Ding
 * @Description: Alias Component
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/ListPage/Alias/index.tsx
 */

import React from 'react';

import { InfoCircleFilled, PlusOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { Button } from '@/src/components/Antd';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import GeneralLinkItem from 'src/constrains/SalesChannelPreviewPageComponents/GeneralLinkItem';
import DuplicateModal from './DuplicateModal';

import { Icon } from '@/src/tools/icon';
import { deleteAlias, duplicateAlias, getAllAlias } from '../slice';

import { duplicateConvertDataFromReduxToServer } from '../tools';

import { nameCopy } from '@/src/tools/helper';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';
const Alias = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    setShowModal,
    setModalContent,
    setModalTitle,
    isOnPrimaryLanguage,
    disabled,
  } = props;
  const aliasData = useSelector(getAllAlias());
  const _d = useDispatch();
  const history = useHistory();
  const _params: {
    salesChannelProductUuid: string;
    saleChannelUuid: string;
  } = useParams();
  const { salesChannelProductUuid, saleChannelUuid } = _params;
  const handleAddNewAlias = () => {
    breakToAlias();
  };
  const breakToAlias = () => {
    history.push(
      `/salesChannel/products/alias/${saleChannelUuid}/${salesChannelProductUuid}/new?length=${
        aliasData.length ? aliasData.length + 1 : 1
      }`,
    );
  };

  const nameList = aliasData.map(
    (item) => (item.contentDetails || {}).productName,
  );

  const duplicateNameCopy = (name) => {
    return nameCopy(name, nameList).substring(0, 100);
  };

  const handleDuplicate = (alias, value) => {
    setShowModal(false);
    const aliasCopy = _.cloneDeep(alias);
    aliasCopy.productName = value;
    aliasCopy.contentUuid = salesChannelProductUuid;

    aliasCopy.duplicate = true;
    _d(duplicateAlias(duplicateConvertDataFromReduxToServer(aliasCopy)));
  };
  const handleDeleteAlias = (uuid) => {
    setShowModal(false);
    _d(deleteAlias(uuid));
  };
  const options = (index) => [
    {
      onClick: () => {
        setShowModal(true);
        setModalTitle(
          getI18n('salesChannelProductAlias.listPage.duplicatealias'),
        );
        setModalContent(
          <DuplicateModal
            setShowModal={setShowModal}
            defaultName={duplicateNameCopy(
              aliasData[index].contentDetails.productName,
            )}
            nameList={nameList}
            handleDuplicate={(value) =>
              handleDuplicate(aliasData[index], value)
            }
          />,
        );
      },
      key: 'Duplicate',
      body: (
        <div className={styles.duplicate}>{getI18n('general.duplicate')}</div>
      ),
    },
    {
      onClick: () => {
        setShowModal(true);
        setModalTitle(
          <div>
            <InfoCircleFilled className={styles.iconWarn} />
            {getI18n('salesChannelProductAlias.listPage.deletesaleschannel')}
          </div>,
        );
        setModalContent(
          <ErrorModal
            setModal={setShowModal}
            onSubmit={() => handleDeleteAlias(aliasData[index].uuid)}
            okText={getI18n('general.delete')}
            errorText={getI18n(
              'salesChannelProductAlias.listPage.deletesaleschanneltips',
            )}
          />,
        );
      },
      key: 'Delete',
      body: <div className={styles.delete}>{getI18n('general.delete')}</div>,
    },
  ];

  return (
    <div>
      <div className={styles.new}>
        {isOnPrimaryLanguage ? (
          <Button
            type='primary'
            block
            icon={<PlusOutlined className={styles.icon} />}
            className={styles.btnNew}
            disabled={disabled}
            onClick={handleAddNewAlias}>
            <span>
              {getI18n('salesChannelProductAlias.listPage.createAlias')}
            </span>
          </Button>
        ) : (
          <div>
            <Icon type='iconinfo' className={styles.infoIcon} />
            {getI18n(
              'salesChannelProductAlias.listPage.createaliasunderprimarylanguage',
            )}
          </div>
        )}
      </div>
      {(aliasData || []).map((alias, index) => (
        <GeneralLinkItem
          key={index}
          onClick={() => {
            history.push(
              `/salesChannel/products/alias/${saleChannelUuid}/${salesChannelProductUuid}/${alias.uuid}`,
            );
          }}
          title={(alias.contentDetails || {}).productName}
          options={disabled ? [] : options(index)}
        />
      ))}
    </div>
  );
};
export default Alias;
